import { axiosEduServer } from "../utils/configAxios";

export const crearTipoAdmision = (data) => {
  return axiosEduServer.post('/tipoadmision', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarTipoAdmision = (id, data) => {
  return axiosEduServer.put(`/tipoadmision/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarTipoAdmision = (id) => {
  return axiosEduServer.delete(`/tipoadmision/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getOneTipoAdmision = (id) => {
  return axiosEduServer.get(`/tipoadmision/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllTipoAdmisiones = () => {
  return axiosEduServer.get('/tipoadmision').then(({ data }) => data).catch((err) => { throw err });
};